import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from './assets/LOGO.jpeg';
import { FiMenu, FiX } from 'react-icons/fi'; // Import des icônes pour le menu

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo redirigeant vers l'accueil */}
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo Etoile Bricolage" />
          </Link>
        </div>

        {/* Bouton hamburger pour mobile */}
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FiX size={30} /> : <FiMenu size={30} />}
        </button>

        {/* Navigation */}
        <nav className={`nav ${menuOpen ? "nav-open" : ""}`}>
          <ul className="nav-links">
            <li><Link to="/" onClick={() => setMenuOpen(false)}>ACCUEIL</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>À PROPOS</Link></li>
            <li><Link to="/products" onClick={() => setMenuOpen(false)}>PRODUITS</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
